module.exports = __webpack_public_path__ + "static/img/appgzh.5e60ebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/appgzh.png
// module id = 28qs
// module chunks = 1